// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2sEmD","vLegacy":"SelectSecondary_vLegacy__1wL_9","error":"SelectSecondary_error__1XoTr","disabled":"SelectSecondary_disabled__2vw6L"};